/* src/app/shared/clearing/clearing-navigation-button/clearing-navigation-button.component.scss */
:host {
  display: block;
  line-height: 1.25;
}
/*# sourceMappingURL=clearing-navigation-button.component.css.map */
